/* ==========================================================================
   AKIKOAOKI — homepage scroll cue ("Side label", study #05)
   Adds a SCROLL button to the first homepage section (the hero slideshow).
   Click: smooth-scroll to the next section. Fades out gradually over the
   first 220px of scrolling and fades back in when scrolling back up.
   Styles: assets/aki-scroll-cue.css.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    var hero = document.querySelector('#main-content > .shopify-section:first-child');
    if (!hero || hero.querySelector('.aki-scroll-cue')) return;
    var next = hero.nextElementSibling;
    if (!next) return;

    var label = (window.akiScrollCue && window.akiScrollCue.label) || 'SCROLL';
    var cue = document.createElement('button');
    cue.type = 'button';
    cue.className = 'aki-scroll-cue';
    cue.setAttribute('aria-label', (window.akiScrollCue && window.akiScrollCue.ariaLabel) || 'Scroll to next section');
    cue.innerHTML = '<span aria-hidden="true"></span><i class="aki-scroll-cue__line" aria-hidden="true"></i>';
    cue.firstChild.textContent = label;

    cue.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = next.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });

    hero.classList.add('aki-scroll-cue-host');
    hero.appendChild(cue);

    // Fade with the scroll: fully visible at the top, gone by FADE_PX.
    // Scrolling back up brings it back the same way.
    var FADE_PX = 220;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ticking = false;
    function update() {
      ticking = false;
      var p = Math.min(Math.max(window.pageYOffset / FADE_PX, 0), 1);
      cue.style.opacity = String(1 - p);
      cue.style.transform = reduceMotion ? '' : 'translateY(' + (-16 * p).toFixed(1) + 'px)';
      cue.classList.toggle('is-hidden', p >= 0.98);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
